import { isSupportedIntersectionObserver } from 'src/common/functions'
import { Platform } from 'quasar'
import { getConfig } from 'src/configs'
import isbot from 'isbot'

const release = require('src/release')
const config = getConfig()

export default {
  state: () => ({
    prevRoute: null,
    lang: 'en',
    underdev: true,
    userDialog: { show: false, type: '', message: '' },
    release: release.version,
    countOfErrorsChunkLoaded: 0,
    isBot: isbot(navigator.userAgent),
    main: config.code === 'b6e48fe2',
    alt: config.code === 'r7cb4846',
  }),
  mutations: {
    UPDATE_ERROR_CHUNKS(state) {
      state.countOfErrorsChunkLoaded++
    },
    UPDATE_PREV_ROUTE(state, value) {
      state.prevRoute = value
    },
    UPDATE_UNDERDEV(state, value) {
      state.underdev = value
    },
  },
  actions: {
    updatePrevRoute({ commit }, value) {
      commit('UPDATE_PREV_ROUTE', value)
    },
    updateUnderDev({ commit }, value) {
      commit('UPDATE_UNDERDEV', value)
    },
  },
  getters: {
    getIsMain: (s) => s.main,
    getIsAlt: (s) => s.alt,
    getPlatformName: (s) => {
      if (s.main) {
        return 'main'
      }

      if (s.alt) {
        return 'alt'
      }

      return ''
    },
    getPrevRoute: (s) => s.prevRoute,
    getCountOfErrorsChunkLoaded: (s) => s.countOfErrorsChunkLoaded,
    getPlatform: () => Platform,
    isMobile: () => {
      if (Platform.is.mobile) {
        return true
      }
      return Platform.is.desktop ? false : Platform.is.ios || Platform.is.android || Platform.is.ipad
    },
    getRelease: (s) => s.release,
    getUnderDev: (s) => s.underdev,
    useIntersectionObserver: () => isSupportedIntersectionObserver(Platform),
    getIsBot: (s) => s.isBot,
  },
}
